import api from './client';

export const syncApi = {
  getStatus: () => api.get('/api/sync/status'),
};
